import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
/**
 * Getters
 */
export const _ProfileGetter = Getter.of();
export const _ProfileResponseGetter = Getter.of();
export const _ProfilesGetter = Getter.of();
export const _ProfilesResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _ProfilesResponse2Profiles = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _ProfilesResponse2Meta = Fold.compose(_ProfilesResponseGetter, Res._Response(), Lens.prop("meta"));
export const _Profile2Data = Fold.compose(_ProfileGetter, Res._Response());
export const _Profiles2Data = Fold.compose(_ProfilesGetter, Res._Response());
export const _Profile2Attributes = Fold.compose(_Profile2Data, Lens.prop("attributes"));
export const _Profiles2Attributes = Fold.compose(_Profiles2Data, Fold._each(), Lens.prop("attributes"));
export const _ProfilesAttributes2AvatarName = Fold.compose(_Profiles2Attributes, Lens.prop("avatarName"));
export const _ProfilesAttributes2IsPreview = Fold.compose(_Profiles2Attributes, Lens.prop("isPreview"));
export const _ProfilesAttributes2ProfileName = Fold.compose(_Profiles2Attributes, Lens.prop("profileName"));
export const _ProfilesAttributes2Age = Fold.compose(_Profiles2Attributes, Lens.prop("age"));
export const _ProfilesAttributes2AgeRestricted = Fold.compose(_Profiles2Attributes, Lens.prop("ageRestricted"));
export const _ProfilesAttributes2PinRestricted = Fold.compose(_Profiles2Attributes, Lens.prop("pinRestricted"));
export const _ProfilesAttributes2Gender = Fold.compose(_Profiles2Attributes, Lens.prop("gender"));
export const _ProfilesAttributes2BandwidthPreference = Fold.compose(_Profiles2Attributes, Lens.prop("bandwidthPreference"));
export const _ProfilesAttributes2BirthYear = Fold.compose(_Profiles2Attributes, Lens.prop("birthYear"));
export const _ProfilesAttributes2BirthMonth = Fold.compose(_Profiles2Attributes, Lens.prop("birthMonth"));
export const _ProfilesAttributes2BirthDay = Fold.compose(_Profiles2Attributes, Lens.prop("birthDay"));
export const _ProfilesAttributes2PreviewInstant = Fold.compose(_Profiles2Attributes, Lens.prop("previewInstant"));
export const _ProfilesAttributes2PreferredLanguageTags = Fold.compose(_Profiles2Attributes, Lens.prop("preferredLanguageTags"));

